import { GridCheckCircleIcon } from "@mui/x-data-grid";
import React from "react";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const successToast = (message) => {
    const settings = secureLocalStorage.getItem("systemSettings");
    const settingsInfo = JSON.parse(settings);
    const mainBackground = settingsInfo?.mainBackground;

    toast.success(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        progressClassName: "toast-progress",
        progressStyle: {
            background: mainBackground,
        },
        icon: <GridCheckCircleIcon sx={
            {
                color: mainBackground,
            }
        } />,
        

    });
};

export const errorToast = (message) => {
    toast.error(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
};

export const warningToast = (message) => {
    toast.warn(message, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
}
